/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Time_InvalidInputs */

const vi_error_irrigation_schedule_time_invalid = /** @type {(inputs: Error_Irrigation_Schedule_Time_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ không hợp lệ, nhập theo dạng giờ:phút (ví dụ 06:30)`)
};

/**

* @param {Error_Irrigation_Schedule_Time_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_time_invalid = /** @type {((inputs?: Error_Irrigation_Schedule_Time_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Time_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_time_invalid(inputs)
});